"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconPluginJourneyRenderingPage = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var React = require("react");
var components_1 = require("@athena-portal/components");
var react_intl_1 = require("react-intl");
var JourneySessionPage_1 = require("./JourneySessionPage");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var services_1 = require("@falcon/services");
var JourneyType_1 = require("../JourneyType");
var SCHEDULED_MAINTENANCE_PAGE_ID = "scheduledMaintenance";
var FalconJourneyRenderingPage = /** @class */ (function (_super) {
    __extends(FalconJourneyRenderingPage, _super);
    function FalconJourneyRenderingPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ANNUAL_HOME_MAINTENANCE_ENABLED = false;
        _this.ANNUAL_MOTOR_MAINTENANCE_ENABLED = false;
        return _this;
    }
    FalconJourneyRenderingPage.prototype.renderJourneyLoader = function (journeyLoaded, serviceError) {
        return (React.createElement(React.Fragment, null,
            React.createElement(components_1.Overlay, { show: (!journeyLoaded) && !serviceError }),
            journeyLoaded && !serviceError && React.createElement(JourneySessionPage_1.JourneySessionPage, { pathname: this.props.location.pathname, pageContext: this.pageContext })));
    };
    FalconJourneyRenderingPage.prototype.navigate = function (pageId, validate, fireEvents, reload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _super.prototype.navigate.call(this, pageId, validate, fireEvents, reload)];
                    case 1:
                        _a.sent();
                        this.changelogRecorder.recordPage("navigate", this.pageContext);
                        return [2 /*return*/, Promise.resolve()];
                }
            });
        });
    };
    FalconJourneyRenderingPage.prototype.decidePageToRender = function (journey) {
        var _a;
        var pageId = null;
        var match = this.props.match;
        if ((_a = match === null || match === void 0 ? void 0 : match.params) === null || _a === void 0 ? void 0 : _a["pageId"]) {
            pageId = match.params["pageId"];
        }
        var journeyManager = new plugin_journey_1.JourneyManager(journey);
        if (this.isMaintenanceEnabled(journey.id)) {
            var page = journeyManager.fetchPage(SCHEDULED_MAINTENANCE_PAGE_ID);
            if (page) {
                return page;
            }
        }
        else if (pageId) {
            var page = journeyManager.fetchPage(pageId);
            if (page) {
                return page;
            }
        }
        return journeyManager.fetchEntryPage();
    };
    FalconJourneyRenderingPage.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var rentersNBEnabled, subscriptionMotorNBEnabled;
            var _this = this;
            return __generator(this, function (_a) {
                rentersNBEnabled = process.env.REACT_APP_RENTERS_NB_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_NB_ENABLED) : false;
                subscriptionMotorNBEnabled = process.env.REACT_APP_MOTOR_NB_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_NB_ENABLED) : false;
                this.falconConvenienceApiService.getSettings()
                    .subscribe(function (settings) {
                    _this.ANNUAL_HOME_MAINTENANCE_ENABLED = (settings === null || settings === void 0 ? void 0 : settings.annual_home_maintenance) === "true" || false;
                    _this.ANNUAL_MOTOR_MAINTENANCE_ENABLED = (settings === null || settings === void 0 ? void 0 : settings.annual_motor_maintenance) === "true" || false;
                });
                if ((!rentersNBEnabled || !subscriptionMotorNBEnabled) && this.isSubscriptionNBPage() && !this.isSubscriptionQuotePage(rentersNBEnabled, subscriptionMotorNBEnabled)) {
                    window.location.replace('https://www.flowinsurance.co.uk/faqs');
                }
                else if (this.props.location &&
                    this.props.location.search &&
                    this.props.location.search.indexOf("auth") !== -1 &&
                    this.guard &&
                    !this.guard.isAuthenticated()) {
                    this.guard.doGuard().subscribe(function (authenticated) {
                        if (authenticated) {
                            _super.prototype.componentDidMount.call(_this);
                        }
                    });
                }
                else {
                    _super.prototype.componentDidMount.call(this);
                }
                return [2 /*return*/];
            });
        });
    };
    FalconJourneyRenderingPage.prototype.validate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = false, _a));
                        return [4 /*yield*/, _super.prototype.validate.call(this)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    FalconJourneyRenderingPage.prototype.determineProduct = function () {
        var pathProduct = this.getPathParam("product");
        return services_1.productHelper.decodeShortenedProduct(pathProduct);
    };
    FalconJourneyRenderingPage.prototype.processJourneyLoadError = function (product, process, interactionId) {
        var url = new URL(window.location.href);
        var referrerAggregator = url.searchParams.get("referrer_aggregator");
        if (referrerAggregator) {
            this.props.history.push("/aggregatorError/".concat(referrerAggregator));
        }
        else {
            this.props.history.push("/retrieveQuote?quote_id=".concat(interactionId));
        }
    };
    FalconJourneyRenderingPage.prototype.isSubscriptionNBPage = function () {
        return window.location.href.includes("/RentersInsurance/process/nb") || window.location.href.includes("/MotorInsurance/process/nb");
    };
    FalconJourneyRenderingPage.prototype.isSubscriptionQuotePage = function (rentersNBEnabled, subscriptionMotorNBEnabled) {
        if ((!rentersNBEnabled && window.location.href.includes("/RentersInsurance/process/nb")) ||
            (!subscriptionMotorNBEnabled && window.location.href.includes("/MotorInsurance/process/nb"))) {
            return (window.location.href.toLowerCase().includes("quote") ||
                window.location.href.toLowerCase().includes("payment") ||
                window.location.href.toLowerCase().includes("purchase") ||
                window.location.href.toLowerCase().includes("summary") ||
                window.location.href.toLowerCase().includes("authvoid"));
        }
        return false;
    };
    FalconJourneyRenderingPage.prototype.isMaintenanceEnabled = function (journeyId) {
        if ((0, JourneyType_1.journeyIdFrom)(JourneyType_1.JourneyType.ANNUAL_HOME, journeyId)) {
            return this.ANNUAL_HOME_MAINTENANCE_ENABLED;
        }
        else if ((0, JourneyType_1.journeyIdFrom)(JourneyType_1.JourneyType.ANNUAL_MOTOR, journeyId)) {
            return this.ANNUAL_MOTOR_MAINTENANCE_ENABLED;
        }
        else {
            return false;
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], FalconJourneyRenderingPage.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        (0, core_1.optional)(),
        __metadata("design:type", Object)
    ], FalconJourneyRenderingPage.prototype, "guard", void 0);
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], FalconJourneyRenderingPage.prototype, "falconConvenienceApiService", void 0);
    return FalconJourneyRenderingPage;
}(plugin_journey_1.PluginJourneyRenderingPage));
var FalconPluginJourneyRenderingPage = (0, react_intl_1.injectIntl)(FalconJourneyRenderingPage);
exports.FalconPluginJourneyRenderingPage = FalconPluginJourneyRenderingPage;
//# sourceMappingURL=FalconJourneyRenderingPage.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/pages/FalconJourneyRenderingPage.js
// module id = 2544
// module chunks = 0